import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  .title {
    text-align: center;
    font-size: 36px;
  }

  .promotion-block {
    margin-top: 40px;
    .swiper {
      .swiper-pagination-bullets {
        margin-bottom: 10px;
        .swiper-pagination-bullet {
          background-color: ${theme.lightGray};
        }
        .swiper-pagination-bullet-active {
          background-color: ${theme.darkRed};
        }
      }
      .swiper-slide {
        border-radius: 30px;
        overflow: hidden;
      }
    }
    .promotion-image-block {
      .image-desktop {
        width: 100%;
        height: 100%;
        aspect-ratio: 1244 / 404;
      }
    }
  }

  .promotion-button-block {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 52px;
    button {
      span {
        font-size: 32px;
      }
    }
  }

  @media (max-width: ${breakpoint.md}) {
    .title {
      font-size: 20px;
    }
    .promotion-block {
      margin-top: 20px;
      .swiper {
        .swiper-pagination-bullets {
          margin-bottom: 0px;
        }
        .swiper-slide {
          border-radius: 10px;
        }
      }
      .promotion-image-block {
        .img-mobile {
          aspect-ratio: 360 / 223;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
    .promotion-button-block {
      button {
        span {
          font-size: 16px;
        }
      }
    }
  }
`
